import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/line-beacon`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const beaconApi = {
  getBeaconsList: (request) => {
    const { config, pageId } = request
    const url = `/${pageId}/config`
    return instance().get(url, {
      params: config
    })
  },
  postCreateBeacon: (request) => {
    const { data } = request
    const url = `/${data.pageid}/save-config`
    return instance().post(url, data.body)
  },
  deleteBeaconItem: (request) => {
    const { data } = request
    const url = `/${data.pageid}/config/${data.config_id}`
    return instance().delete(url)
  },
  getReportMessageBeaconsList: (request) => {
    const { config } = request
    const url = `/${config.pageid}/report-message`
    return instance().get(url, {
      params: config.params
    })
  },
  getReportUserByDateBeaconsList: (request) => {
    const { config } = request
    const url = `/${config.pageid}/report-user-by-date`
    return instance().get(url, {
      params: config.params
    })
  },

  getReportUserByTimeBeaconsList: (request) => {
    const { config } = request
    const url = `/${config.pageid}/report-user-by-time`
    return instance().get(url, {
      params: config.params
    })
  },
  getIntentBeacon: (request) => {
    const { config } = request
    const url = `/${config.pageid}/campaign`
    return instance().get(url)
  },
  postAddIntentBeacon: (request) => {
    const { data } = request
    const url = `/${data.pageid}/campaign`
    return instance().post(url, data)
  },
  putUpdateIntentBeacon: (request) => {
    const { data } = request
    const url = `/${data.pageid}/campaign/${data.id}`
    return instance().put(url, data)
  },
  deleteIntentBeacon: (request) => {
    const { pageId, id } = request
    const url = `/${pageId}/campaign/${id}`
    return instance().delete(url)
  },
  getAnalyticsUserMessages: (request) => {
    const { config } = request
    const url = `/${config.pageid}/analytic/users-messages`
    return instance().get(url, { params: config.data })
  },
  getAnalyticsMetricUsersGroupAudienceByDate: (request) => {
    const { config } = request
    const url = `/${config.pageid}/analytic/metric-group-audience/users-by-date`
    return instance().get(url, { params: config.data })
  },
  getAnalyticsMetricMessagesGroupAudienceByTime: (request) => {
    const { config } = request
    const url = `/${config.pageid}/analytic/metric-group-audience/messages-by-time`
    return instance().get(url, { params: config.data })
  },
  getAnalyticsMetricUsersByDate: (request) => {
    const { config } = request
    const url = `/${config.pageid}/analytic/metric-beacon/users-by-date`
    return instance().get(url, { params: config.data })
  },
  getAnalyticsMetricMessagesByTime: (request) => {
    const { config } = request
    const url = `/${config.pageid}/analytic/metric-beacon/messages-by-time`
    return instance().get(url, { params: config.data })
  },
  getAnalyticsCustomer: (request) => {
    const { config } = request
    const url = `/${config.pageid}/analytic/customer`
    return instance().get(url, { params: config.data })
  },
  getAnalyticsCustomerTransaction: (request) => {
    const { config } = request
    const url = `/${config.pageid}/analytic/customer-transaction`
    return instance().get(url, { params: config.data })
  }
}
export default beaconApi



// WEBPACK FOOTER //
// ./src/api/beacon.js